<template>
  <div class="detail">
    <Navigation />
    <div 
        class="content-container mp-container"
        v-if="detail"
    >
        <div
            class="aside-left clickable"
            @click="navTo('rundgang')"
        ><img
            src="/img/museum-pankow-grundriss_icon.png"
            class="plan-icon"
        ></div>
        <div class="main">
          <div
            class="player-container"
            v-if="detail && detail.video"
          >
            <video
                
                width="100%"
                controls
                autoplay
                crossOrigin="anonymous"
            >
                <source :src="detail.video.url" type="video/mp4" crossOrigin="anonymous">
                Your browser does not support HTML5 video.
            </video>
            <div class="video-navi">
              <div
                class="nav-element clickable"
                @click="nextVideo(-1)"
              >
                <img class="arrow" src="/img/pfeil-links.svg">
                <span class="arrow-label">zurück</span>
              </div>
              <div class="preview-title">{{ detail.title}}</div>
              <div
                class="nav-element clickable"
                @click="nextVideo(1)"
              >
                <span class="arrow-label">nächstes</span>
                <img class="arrow" src="/img/pfeil-rechts.svg">
              </div>
            </div>
          </div>
          <div 
            class="back-to-room clickable"
            @click="$router.go(-1)"
          >
            Zurück zum Raum ...
        </div>
        </div>
        <!-- <div
            class="aside-right "
            v-if="room"
        >
            <DetailList :current="room.orderNumber"/>
        </div> -->
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
// import DetailList from '@/components/Detail-list'
import Navigation from '@/components/Navigation'

export default {
  name: 'detail-display',
  components: {
    // DetailList,
    Navigation
  },
  data () {
    return {
        roomNumber: null,
        showDetail: false
    }
  },
  methods: {
    navTo(target) {
        this.$router.push(`/${target}`)
    },
    nextVideo(dir) {
      const nums = this.videos.map(v => {
        return parseInt(v.orderNumber)
      })
      const currNum = parseInt(this.$route.params.id)
      const currPos = nums.indexOf(currNum)
      let newPos = currPos + dir
      if (newPos < 0) newPos = nums.length -1
      if (newPos > nums.length -1) newPos = 0

      this.$router.push(`/video/${nums[newPos]}`)
    }
  },
  computed: {
    ...mapGetters({
      pagesData: 'getPagesData',
      rooms: 'getRoomsData',
      detail: 'getDetailVideo'
    }),
    room() {
        return this.$route.params.raum
    }
  },
  created () {
    this.roomNumber = this.$route.params.id
    if(!this.detail.title) this.$router.push('/rundgang')   
  }
}
</script>
<style lang="scss" scoped>
@import '@/scss/custom.scss';
.video {
    position: relative;
}
.content-container {
    display: grid;
    grid-template-columns: auto 1fr auto;
    padding-top: 6rem;
    align-content: space-between;
}
.main {
    margin: 2rem 6rem 2rem 4rem;
}
.aside-left {
    margin: 2rem 1rem;
    .plan-icon {
        max-width: 8rem;
    }
}
.player-container {
   background-color: $grey-light-80;
   max-width: calc(100vw - 26rem);
}
.video-navi {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: $grey-light-80;
  min-height: 4rem;
  .nav-element {
    padding: .6rem 1rem;
    // provisorisch
    opacity: 0;
    .arrow-label {
      padding: 1rem;
      font-family: 'tangerine', serif;
      font-weight: 700;
      font-size: 2.2rem;
      color: $sand-dark;
    }
  }
  .arrow {
    display: inline-block;
    width: 4rem;
  }
  .preview-title {
    padding: 1rem;
    font-family: 'Titillium Web', sans-serif;
    font-weight: 400;
    font-size: 1.2rem;
    color: $sand-dark;
  }
}
.back-to-room {
    font-size: 1.4rem;
    text-align: center;
    margin-top: 1rem;
    color: $red-dark;
    font-family: 'Titillium Web';
    font-weight: 600;

}
</style>